export const PRODUCTS = {
    IMAGOADMIN: 'imagoadmin',
};

export const ROUTES = {
    ROOT_PATH: '/',
    LOGIN: '/login',
    LOGIN_AUTH: '/login/auth/:apiToken',
    INSTANCES: '/instances',
    INSTANCE_DETAIL: '/instances/:id',
    USERS: '/users',
    SUPPORT_PACKAGES: '/support-packages',
    ACTIVE_VERSIONS: '/active-versions',
    ACTIVE_VERSIONS_DRILLDOWN: '/active-versions/:product/:version',
};

export const LEGACY_TOKEN_TYPE = 'imago-legacy';
